/**
 * 查找父级组件
 * @param context 上下文
 * @param componentName 组件名
 * @returns {Vue}
 */
function findParentComponent(context, componentName) {
  if (typeof componentName === 'string') {
    componentName = [componentName];
  }

  let parent = context.$parent;
  let name = parent.$options.name;
  while (parent && (!name || componentName.indexOf(name) < 0)) {
    parent = parent.$parent;
    if (parent) name = parent.$options.name;
  }
  return parent;
}

/**
 * 判断是否为IE某个版本
 * @param ver IE版本
 * @returns {boolean}
 */
function isIE(ver) {
  var b = document.createElement('b');
  b.innerHTML = `<!--[if IE ${ver}]><i></i><![endif]-->`;
  return b.getElementsByTagName('i').length === 1;
}

// 字节转换
function readablizeBytes(bytes) {
  const s = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB'];
  const e = Math.floor(Math.log(bytes) / Math.log(1024));
  return (bytes / Math.pow(1024, Math.floor(e))).toFixed(2) + ' ' + s[e];
}

function isType(value, type) {
  return {}.toString.call(value) === `[object ${type}]`;
}

export {
  findParentComponent,
  isIE,
  readablizeBytes,
  isType,
};
